import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/utils/tailwind.util';
export type ChipProps = ComponentPropsWithoutRef<'span'> & {
  rounded?: 'default' | 'full';
  size?: 'lg' | 'md' | 'sm' | 'xs';
  leftSlot?: React.JSX.Element;
  rightSlot?: React.JSX.Element;
};
const chipVariants = cva('flex w-fit items-center border border-neutral bg-default text-neutral', {
  variants: {
    size: {
      lg: 'min-h-xl gap-3xs rounded-sm px-xs text-body-sm-bold',
      md: 'min-h-[26px] gap-4xs rounded-xs px-xs text-body-sm-semibold',
      sm: 'min-h-[22px] gap-4xs rounded-xs px-2xs text-caption-md-semibold',
      xs: 'min-h-[18px] gap-0 rounded-xs px-2xs text-caption-md-semibold'
    },
    rounded: {
      default: '',
      full: 'rounded-full'
    }
  }
});
export const Chip = forwardRef<HTMLSpanElement, ChipProps>(({
  className,
  children,
  size = 'lg',
  leftSlot,
  rightSlot,
  rounded = 'default',
  ...props
}, ref) => {
  return <span ref={ref} className={cn(chipVariants({
    size,
    rounded
  }), className)} {...props}>
        {leftSlot}
        {children}
        {rightSlot}
      </span>;
});
Chip.displayName = 'Chip';